import { render, staticRenderFns } from "./ContentDiscoveryChannel.vue?vue&type=template&id=be103792&"
import script from "./ContentDiscoveryChannel.vue?vue&type=script&lang=js&"
export * from "./ContentDiscoveryChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports